/* eslint-disable */
export default {
  logging: 'Connexion en cours…',
  logCall: 'Journal des appels',
  editLog: 'Modifier le journal',
  select: 'Sélectionner une correspondance de registre',
  OnHold: 'En attente',
  Ringing: 'Sonnerie en cours',
  CallConnected: 'Appel établi',
  unknownUser: 'Utilisateur inconnu',
  unknownNumber: 'Anonyme',
  unavailable: 'Non disponible',
  viewDetails: 'Afficher les détails',
  addEntity: 'Créer nouveau',
  addLog: 'Journal',
  text: 'SMS',
  call: 'Appel',
  addContact: 'Ajouter un contact',
  missedCall: 'Manqué',
  inboundCall: 'Entrant',
  outboundCall: 'Sortant',
  from: 'De',
  to: 'À',
  hangup: 'Raccrocher',
  accept: 'Répondre',
  toVoicemail: 'Vers messag.',
  anonymous: 'Anonyme',
  mergeToConference: 'Fusionner avec l’appel actif',
  hold: 'Mettre en attente',
  unhold: 'Reprendre l’appel',
  transfer: 'Transférer',
  reject: 'Rejeter',
  switchCall: 'Transférer l’appel sur cette application',
  callSwitch: 'Commutation d’appel',
  comfirmContext:
    'Vous avez actuellement un appel actif avec {displayName}. Souhaitez-vous continuer l’appel sur ce terminal ?',
  comfirmCancelButton: 'Annuler',
  comfirmOKButton: 'Commuter',
  ignore: 'Ignorer',
  holdAndAnswer: 'Attente et rép.',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"addContact"@#@ @source: @#@"Add Contact"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"accept"@#@ @source: @#@"Answer"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"unhold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"switchCall"@#@ @source: @#@"Switch Call to this app"@#@
// @key: @#@"callSwitch"@#@ @source: @#@"Call Switch"@#@
// @key: @#@"comfirmContext"@#@ @source: @#@"You're currently on an active call with {displayName}. Would you like to continue the call on this device?"@#@
// @key: @#@"comfirmCancelButton"@#@ @source: @#@"Cancel"@#@
// @key: @#@"comfirmOKButton"@#@ @source: @#@"Switch"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
